import { IIsPrintSetAction } from './types';
import { AT_IS_PRINT_SET } from './constants';

export const isPrintSetAction = (
    isPrint: boolean
): IIsPrintSetAction => ({
    type: AT_IS_PRINT_SET,
    isPrint
});
